import React from 'react';
import { equipmentTypes } from 'constants/Equipment';
import { Button, Label, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, } from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import FormGrid from './FormGrid';
export default function EquipmentTypeRateConditionField({ condition, onChange, onRemove, }) {
    const { criteria: value } = condition;
    function handleRemove() {
        onRemove(condition);
    }
    function handleChange(criteria) {
        onChange(Object.assign(Object.assign({}, condition), { criteria }));
    }
    return (React.createElement(FormGrid, null,
        React.createElement(Label, { className: "w-48" }, "Equipment"),
        React.createElement(Select, { className: "flex-1", value: value, onValueChange: handleChange },
            React.createElement(SelectTrigger, { className: "" },
                React.createElement(SelectValue, { placeholder: "Equipment Type" })),
            React.createElement(SelectContent, null,
                React.createElement(SelectGroup, null,
                    React.createElement(SelectLabel, null, "Equipment"),
                    Object.values(equipmentTypes).map((equipmentType) => (React.createElement(SelectItem, { value: equipmentType, key: equipmentType }, equipmentType)))))),
        React.createElement("div", null,
            React.createElement(Button, { variant: "icon", onClick: handleRemove },
                React.createElement(Trash, { className: "w-3.5 h-3.5" })))));
}
